'use client';

import { deferOverlayComponent } from '@eliadmin/core/src/components/ui/dialog';
import type { AdultDialog as CoreAdultDialog } from '../../../node_modules/@eliadmin/core/src/components/adult-consent/adult-dialog';

// The server retains the original popup_adult_only eligibility check. If enabled,
// render the unchanged installed core implementation, including its consent policy.
export const AdultDialog = deferOverlayComponent<typeof CoreAdultDialog>(
  () => import('../../../node_modules/@eliadmin/core/src/components/adult-consent/adult-dialog')
    .then(runtime => runtime.AdultDialog),
  'AdultDialog',
);
